import axios from "../../utils/axios";

async function fetchList(params) {
  const response = await axios.get("single/reviews", { params });
  return response;
}

export const reviewService = {
  fetchList,
};
